module.exports = __webpack_public_path__ + "img/2.b2fdad74.png";